import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import React, { useEffect } from "react";
const YotpoStars = ({ product }) => {
    useEffect(() => {
        // @ts-ignore
        if (typeof window.yotpo !== "undefined") {
            // @ts-ignore
            window.yotpo.refreshWidgets();
        }
    }, []);
    return (_jsxs(_Fragment, { children: [_jsx("div", { className: "yotpo bottomLine review-stars", "data-product-id": product, style: { maxWidth: "1000px", margin: "auto" }, "data-currency": "USD", "data-name": product?.toUpperCase(), "data-url": "https://gainful.com/", "data-image-url": "https://gainful.com/", children: " " }), _jsx("script", { async: true, type: "text/javascript", src: "//staticw2.yotpo.com/una68euqrjMwMKwu7UWT4WgF9VLHwUA7gke5fPAR/widget.js" })] }));
};
export default YotpoStars;
